interface IOption{
    expires?:number;
    path?:string;
    domain?:string;
    secure?:string;
}

export default class Cookie {
  static isNode: boolean =  typeof document === 'undefined';

  static get(key:string, source?: Record<string, string>): string | undefined {
    const cookieStr = (Cookie.isNode ? source?.cookie : document?.cookie) || '';
    const result: Record<string, string> = {};
    const cookies = cookieStr.split('; ');
    for (let i = 0, len = cookies.length; i < len; i++) {
      const parts = cookies[i].split('=');
      const k = decodeURIComponent(parts[0]);
      result[k] = decodeURIComponent(parts[1]);
    }
    return result[key];
  }

  static set(key:string, value:string, option:IOption = {}):void {
    if (!Cookie.isNode) {
      document.cookie = [
        encodeURIComponent(key), '=', encodeURIComponent(value),
        option.expires ? '; expires=' + new Date(Date.now() + option.expires).toUTCString() : '',
        option.path ? '; path=' + option.path : '',
        option.domain ? '; domain=' + option.domain : '',
        option.secure ? '; secure' : '',
      ].join('');
    }
  }

  static remove(key:string):void {
    if (!Cookie.isNode) {
      if (this.get(key) !== undefined) {
        this.set(key, '', { expires: -1 });
      }
    }
  }

  static clear():void {
    if (!Cookie.isNode) {
      const cookies = document.cookie ? document.cookie.split('; ') : [];
      for (let i = 0, len = cookies.length; i < len; i++) {
        const parts = cookies[i].split('=');
        const key = decodeURIComponent(parts[0]);
        this.remove(key);
      }
    }
  }
}
